"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var ButtonWrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "DialogFooter__ButtonWrapper",
  componentId: "sc-44zalc-0"
})(["flex-wrap:wrap;"]);

var DialogFooter = function DialogFooter(_ref) {
  var actions = _ref.actions,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["actions"]);
  return _react["default"].createElement(ButtonWrapper, (0, _extends2["default"])({
    width: 1 / 1,
    flexDirection: ["row-reverse"]
  }, props), actions.map(function (action, index) {
    return _react["default"].createElement(_Button["default"], {
      width: "auto",
      key: action.label,
      onClick: action.action,
      disabled: action.isDisabled,
      elevation: 0,
      variant: index === 0 ? "text.primary.0" : "text.dark.3",
      ml: 2
    }, action.label);
  }));
};

DialogFooter.propTypes = {
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].func.isRequired,
    isDisabled: _propTypes["default"].bool
  })).isRequired
};
var _default = DialogFooter;
exports["default"] = _default;